/* Testimonial Block  */
if (!customElements.get('product-testimonials')) {
  class ProductTestimonials extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
    }

    connectedCallback() {
      if (this.swiper) return;

      this.slider = this.querySelector(
        '[data-product-testimonials-swiper]'
      );

      this.nextButton = this.querySelector(
        '[data-product-testimonials-next]'
      );

      if (!this.slider) return;

      if (typeof window.Swiper !== 'function') {
        console.warn(
          'Swiper is not loaded for product testimonials.'
        );

        return;
      }

      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 400,
        autoHeight: true,
        grabCursor: true,
        watchOverflow: true,
        allowTouchMove: true,

        navigation: this.nextButton
          ? {
              nextEl: this.nextButton
            }
          : undefined
      });
    }

    disconnectedCallback() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define(
    'product-testimonials',
    ProductTestimonials
  );
}
/* Testimonial Block  */


/* People View */

if (!customElements.get('people-viewing')) {
  class PeopleViewing extends HTMLElement {
    connectedCallback() {
      this.countElement = this.querySelector(
        '[data-people-viewing-count]'
      );

      if (!this.countElement) return;

      const min = Number.parseInt(this.dataset.min, 10);
      const max = Number.parseInt(this.dataset.max, 10);
      const productId = this.dataset.productId;

      if (
        Number.isNaN(min) ||
        Number.isNaN(max) ||
        min > max
      ) {
        return;
      }

      const storageKey = `people-viewing-${productId}`;

      let count = Number.parseInt(
        sessionStorage.getItem(storageKey),
        10
      );

      if (
        Number.isNaN(count) ||
        count < min ||
        count > max
      ) {
        count = this.getRandomNumber(min, max);

        sessionStorage.setItem(
          storageKey,
          String(count)
        );
      }

      this.countElement.textContent = count;
    }

    getRandomNumber(min, max) {
      return Math.floor(
        Math.random() * (max - min + 1)
      ) + min;
    }
  }

  customElements.define(
    'people-viewing',
    PeopleViewing
  );
}

// media gallery 

if (!customElements.get('product-media-gallery')) {
  class ProductMediaGallery extends HTMLElement {
    constructor() {
      super();

      this.mainSwiper = null;
      this.thumbnailSwiper = null;
    }

    connectedCallback() {
      if (this.mainSwiper) return;

      this.mainElement = this.querySelector(
        '[data-product-media-main]'
      );

      this.thumbnailElement = this.querySelector(
        '[data-product-media-thumbnails]'
      );

      this.previousButton = this.querySelector(
        '[data-product-media-previous]'
      );

      this.nextButton = this.querySelector(
        '[data-product-media-next]'
      );

      if (!this.mainElement) return;

      if (typeof window.Swiper !== 'function') {
        console.warn(
          'Swiper is not loaded for the product media gallery.'
        );

        return;
      }

      const initialSlide =
        Number.parseInt(this.dataset.initialSlide, 10) || 0;

      if (this.thumbnailElement) {
        this.thumbnailSwiper = new window.Swiper(
          this.thumbnailElement,
          {
            slidesPerView: 3,
            spaceBetween: 4,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            freeMode: true,

            breakpoints: {
              750: {
                slidesPerView: 3,
                spaceBetween: 6
              }
            }
          }
        );
      }

      this.mainSwiper = new window.Swiper(
        this.mainElement,
        {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 400,
          initialSlide,
          autoHeight: true,
          grabCursor: true,
          allowTouchMove: true,
          watchOverflow: true,

          thumbs: this.thumbnailSwiper
            ? {
                swiper: this.thumbnailSwiper
              }
            : undefined,

          navigation:
            this.previousButton && this.nextButton
              ? {
                  prevEl: this.previousButton,
                  nextEl: this.nextButton
                }
              : undefined,

          on: {
            init: (swiper) => {
              this.updateMediaPlayback(swiper);
            },

            slideChangeTransitionStart: (swiper) => {
              this.updateMediaPlayback(swiper);
            },

            slideChangeTransitionEnd: (swiper) => {
              this.updateMediaPlayback(swiper);
            }
          }
        }
      );
    }

    disconnectedCallback() {
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
        this.mainSwiper = null;
      }

      if (this.thumbnailSwiper) {
        this.thumbnailSwiper.destroy(true, true);
        this.thumbnailSwiper = null;
      }
    }

    updateMediaPlayback(swiper) {
      const slides = Array.from(swiper.slides);

      slides.forEach((slide, index) => {
        const isActive = index === swiper.activeIndex;
        const video = slide.querySelector('video');
        const externalVideo = slide.querySelector('iframe');
        const model = slide.querySelector('model-viewer');

        if (video) {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;

          if (isActive) {
            const playPromise = video.play();

            if (
              playPromise &&
              typeof playPromise.catch === 'function'
            ) {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
          }
        }

        if (externalVideo) {
          this.updateExternalVideo(
            externalVideo,
            isActive
          );
        }

        if (!isActive && model?.pause) {
          model.pause();
        }
      });
    }

    updateExternalVideo(iframe, shouldPlay) {
      const source = iframe.getAttribute('src');

      if (!source) return;

      try {
        const url = new URL(source, window.location.origin);

        if (source.includes('youtube')) {
          iframe.contentWindow?.postMessage(
            JSON.stringify({
              event: 'command',
              func: shouldPlay
                ? 'playVideo'
                : 'pauseVideo',
              args: []
            }),
            '*'
          );
        }

        if (source.includes('vimeo')) {
          iframe.contentWindow?.postMessage(
            {
              method: shouldPlay ? 'play' : 'pause'
            },
            '*'
          );
        }
      } catch (error) {
        console.warn(
          'Could not control external product video.',
          error
        );
      }
    }
  }

  customElements.define(
    'product-media-gallery',
    ProductMediaGallery
  );
}

// class AjaxProductForm {
//   constructor() {
//     this.form = document.querySelector('#add-to-cart-form');
//     this.submitButton = this.form?.querySelector('#purchase');

//     if (!this.form || !this.submitButton) return;

//     this.handleSubmit = this.handleSubmit.bind(this);
//     this.form.addEventListener('submit', this.handleSubmit);
//   }

//   async handleSubmit(event) {
//     event.preventDefault();

//     if (this.submitButton.disabled) return;

//     this.setLoading(true);
//     this.clearError();

//     try {
//       const formData = new FormData(this.form);

//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           Accept: 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: formData
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           result.description ||
//           result.message ||
//           'Unable to add product to cart.'
//         );
//       }

//       document.dispatchEvent(
//         new CustomEvent('cart:added', {
//           detail: result
//         })
//       );

//       await this.refreshCartDrawer();

//       this.openCartDrawer();
//     } catch (error) {
//       console.error('Custom cart add error:', error);

//   const message = this.getErrorMessage(error);

//   this.showFormError(form, message);
//   this.announce(message);
//     } finally {
//       this.setLoading(false);
//     }
//   }

//   async refreshCartDrawer() {
//     try {
//       const response = await fetch('/cart.js', {
//         headers: {
//           Accept: 'application/json'
//         }
//       });

//       if (!response.ok) return;

//       const cart = await response.json();

//       document
//         .querySelectorAll(
//           '.cart-item-count, .cart-item-count-header--quantity'
//         )
//         .forEach((element) => {
//           element.textContent = cart.item_count;
//         });

//       document.dispatchEvent(
//         new CustomEvent('cart:updated', {
//           detail: cart
//         })
//       );
//     } catch (error) {
//       console.error('Cart refresh failed:', error);
//     }
//   }

//   openCartDrawer() {
//     const drawer = document.querySelector('#cartSlideoutWrapper');
//     const cartTrigger = document.querySelector('.slide-menu-cart');

//     if (!drawer || !cartTrigger) {
//       console.error('Cart drawer or cart trigger not found.');
//       return;
//     }

//     const isClosed = drawer.classList.contains(
//       'slideout-panel-hidden'
//     );

//     if (isClosed) {
//       cartTrigger.click();
//     }
//   }

//   setLoading(isLoading) {
//     this.submitButton.disabled = isLoading;
//     this.submitButton.classList.toggle('disabled', isLoading);

//     this.submitButton.textContent = isLoading
//       ? 'Adding...'
//       : 'Add to cart';
//   }

//   clearError() {
//     this.form.querySelector('.custom-cart-error')?.remove();
//   }

//   showError(message) {
//     const errorElement = document.createElement('div');

//     errorElement.className = 'custom-cart-error';
//     errorElement.setAttribute('role', 'alert');
//     errorElement.textContent = message;

//     this.submitButton.insertAdjacentElement(
//       'afterend',
//       errorElement
//     );
//   }
// }

// document.addEventListener('DOMContentLoaded', () => {
//   new AjaxProductForm();
// });

// (() => {
//   if (window.CustomPdpCartInitialized) return;
//   window.CustomPdpCartInitialized = true;

//   class CustomPdpCart {
//     constructor() {
//       this.drawerSelector = '#CustomCartDrawer';
//       this.formSelector = '#add-to-cart-form';
//       this.submitButtonSelector = '#purchase';

//       this.isAdding = false;
//       this.isUpdating = false;
//       this.lastFocusedElement = null;

//       this.handleDocumentClick =
//         this.handleDocumentClick.bind(this);

//       this.handleDocumentSubmit =
//         this.handleDocumentSubmit.bind(this);

//       this.handleDocumentChange =
//         this.handleDocumentChange.bind(this);

//       this.handleKeydown =
//         this.handleKeydown.bind(this);

//       this.init();
//     }

//     init() {
//       /*
//        * Capture mode is important because the existing theme
//        * already has a click handler on #purchase.
//        */
//       document.addEventListener(
//         'click',
//         this.handleDocumentClick,
//         true
//       );

//       document.addEventListener(
//         'submit',
//         this.handleDocumentSubmit,
//         true
//       );

//       document.addEventListener(
//         'change',
//         this.handleDocumentChange
//       );

//       document.addEventListener(
//         'keydown',
//         this.handleKeydown
//       );
//     }

//     get drawer() {
//       return document.querySelector(
//         this.drawerSelector
//       );
//     }

//     getRoute(path) {
//       const root =
//         window.Shopify?.routes?.root || '/';

//       return `${root}${path}`.replace(
//         /([^:]\/)\/+/g,
//         '$1'
//       );
//     }

//     handleDocumentClick(event) {
//       const openTrigger = event.target.closest(
//         '[data-custom-cart-open]'
//       );

//       if (openTrigger) {
//         event.preventDefault();
//         event.stopPropagation();
//         event.stopImmediatePropagation();

//         this.openDrawer(openTrigger);
//         return;
//       }

//       const closeTrigger = event.target.closest(
//         '[data-cart-drawer-close]'
//       );

//       if (closeTrigger) {
//         event.preventDefault();

//         this.closeDrawer();
//         return;
//       }

//       /*
//        * PDP Add to Cart button.
//        * Capture click before the old theme listener.
//        */
//       const submitButton = event.target.closest(
//         this.submitButtonSelector
//       );

//       if (submitButton) {
//         const form = submitButton.closest(
//           this.formSelector
//         );

//         if (!form) return;

//         event.preventDefault();
//         event.stopPropagation();
//         event.stopImmediatePropagation();

//         this.addProduct(form, submitButton);
//         return;
//       }

//       const minusButton = event.target.closest(
//         '[data-cart-quantity-minus]'
//       );

//       if (minusButton && this.drawer?.contains(minusButton)) {
//         event.preventDefault();

//         const line = Number(
//           minusButton.dataset.line
//         );

//         const input = this.drawer.querySelector(
//           `[data-cart-quantity-input][data-line="${line}"]`
//         );

//         if (!input) return;

//         const currentQuantity =
//           Number(input.value) || 0;

//         this.changeQuantity(
//           line,
//           Math.max(0, currentQuantity - 1)
//         );

//         return;
//       }

//       const plusButton = event.target.closest(
//         '[data-cart-quantity-plus]'
//       );

//       if (plusButton && this.drawer?.contains(plusButton)) {
//         event.preventDefault();

//         const line = Number(
//           plusButton.dataset.line
//         );

//         const input = this.drawer.querySelector(
//           `[data-cart-quantity-input][data-line="${line}"]`
//         );

//         if (!input) return;

//         const currentQuantity =
//           Number(input.value) || 0;

//         this.changeQuantity(
//           line,
//           currentQuantity + 1
//         );

//         return;
//       }

//       const removeButton = event.target.closest(
//         '[data-cart-remove]'
//       );

//       if (
//         removeButton &&
//         this.drawer?.contains(removeButton)
//       ) {
//         event.preventDefault();

//         const line = Number(
//           removeButton.dataset.line
//         );

//         this.changeQuantity(line, 0);
//         return;
//       }

//       const recommendationButton =
//         event.target.closest(
//           '[data-recommendation-add]'
//         );

//       if (
//         recommendationButton &&
//         this.drawer?.contains(
//           recommendationButton
//         )
//       ) {
//         event.preventDefault();

//         this.addRecommendation(
//           recommendationButton
//         );
//       }
//     }

//     handleDocumentSubmit(event) {
//       const form = event.target.closest(
//         this.formSelector
//       );

//       if (!form) return;

//       event.preventDefault();
//       event.stopPropagation();
//       event.stopImmediatePropagation();

//       const submitButton =
//         event.submitter ||
//         form.querySelector(
//           this.submitButtonSelector
//         );

//       this.addProduct(form, submitButton);
//     }

//     handleDocumentChange(event) {
//       const quantityInput = event.target.closest(
//         '[data-cart-quantity-input]'
//       );

//       if (
//         !quantityInput ||
//         !this.drawer?.contains(quantityInput)
//       ) {
//         return;
//       }

//       const line = Number(
//         quantityInput.dataset.line
//       );

//       const quantity = Math.max(
//         0,
//         Number(quantityInput.value) || 0
//       );

//       this.changeQuantity(line, quantity);
//     }

//     handleKeydown(event) {
//       if (
//         event.key === 'Escape' &&
//         this.drawer?.classList.contains('is-open')
//       ) {
//         this.closeDrawer();
//       }
//     }

//     async addProduct(form, submitButton) {
//       if (
//         this.isAdding ||
//         this.isUpdating ||
//         submitButton?.disabled
//       ) {
//         return;
//       }

//       this.isAdding = true;

//       this.clearFormError(form);
//       this.setButtonLoading(
//         submitButton,
//         true
//       );

//       try {
//         const formData = new FormData(form);

//         const variantId = formData.get('id');

//         if (!variantId) {
//           throw new Error(
//             'Please select a product option.'
//           );
//         }

//         const response = await fetch(
//           this.getRoute('cart/add.js'),
//           {
//             method: 'POST',
//             headers: {
//               Accept: 'application/json',
//               'X-Requested-With':
//                 'XMLHttpRequest'
//             },
//             body: formData,
//             credentials: 'same-origin'
//           }
//         );

//         const result = await this.parseResponse(
//           response
//         );

//         if (!response.ok) {
//           throw new Error(
//             result.description ||
//             result.message ||
//             'Unable to add this item to cart.'
//           );
//         }

//         await this.refreshDrawer();

//         this.openDrawer(submitButton);

//         this.announce(
//           'Item added to your cart.'
//         );

//         document.dispatchEvent(
//           new CustomEvent(
//             'custom-cart:added',
//             {
//               detail: result
//             }
//           )
//         );
//       } catch (error) {
//         console.error(
//           'Custom cart add error:',
//           error
//         );

//         this.showFormError(
//           form,
//           error.message ||
//           'Unable to add this item to cart.'
//         );

//         this.announce(
//           error.message ||
//           'Unable to add this item to cart.'
//         );
//         console.error('Custom cart add error:', error);

//   const message = this.getErrorMessage(error);

//   this.showFormError(form, message);
//   this.announce(message);
//       } finally {
//         this.isAdding = false;

//         this.setButtonLoading(
//           submitButton,
//           false
//         );
//       }
//     }

//     async changeQuantity(line, quantity) {
//       if (
//         this.isUpdating ||
//         !line ||
//         Number.isNaN(quantity)
//       ) {
//         return;
//       }

//       this.isUpdating = true;
//       this.setDrawerLoading(true);

//       try {
//         const response = await fetch(
//           this.getRoute('cart/change.js'),
//           {
//             method: 'POST',
//             headers: {
//               'Content-Type':
//                 'application/json',
//               Accept: 'application/json',
//               'X-Requested-With':
//                 'XMLHttpRequest'
//             },
//             body: JSON.stringify({
//               line,
//               quantity
//             }),
//             credentials: 'same-origin'
//           }
//         );

//         const result = await this.parseResponse(
//           response
//         );

//         if (!response.ok) {
//           throw new Error(
//             result.description ||
//             result.message ||
//             'Unable to update cart.'
//           );
//         }

//         await this.refreshDrawer();

//         this.openDrawer();

//         this.announce(
//           quantity === 0
//             ? 'Item removed from cart.'
//             : 'Cart quantity updated.'
//         );

//         document.dispatchEvent(
//           new CustomEvent(
//             'custom-cart:updated',
//             {
//               detail: result
//             }
//           )
//         );
//       } catch (error) {
//         console.error(
//           'Custom cart update error:',
//           error
//         );

//         this.announce(
//           error.message ||
//           'Unable to update cart.'
//         );

//         /*
//          * Re-render old correct cart state if update fails.
//          */
//         try {
//           await this.refreshDrawer();
//         } catch (refreshError) {
//           console.error(
//             'Drawer recovery failed:',
//             refreshError
//           );
//         }
//       } finally {
//         this.isUpdating = false;
//         this.setDrawerLoading(false);
//       }
//     }

//     async addRecommendation(button) {
//       if (
//         this.isAdding ||
//         this.isUpdating ||
//         button.disabled
//       ) {
//         return;
//       }

//       const variantId =
//         button.dataset.variantId;

//       if (!variantId) return;

//       this.isAdding = true;

//       const originalHtml = button.innerHTML;

//       button.disabled = true;
//       button.classList.add('is-loading');
//       button.innerHTML = 'Adding...';

//       try {
//         const response = await fetch(
//           this.getRoute('cart/add.js'),
//           {
//             method: 'POST',
//             headers: {
//               'Content-Type':
//                 'application/json',
//               Accept: 'application/json',
//               'X-Requested-With':
//                 'XMLHttpRequest'
//             },
//             body: JSON.stringify({
//               items: [
//                 {
//                   id: Number(variantId),
//                   quantity: 1
//                 }
//               ]
//             }),
//             credentials: 'same-origin'
//           }
//         );

//         const result = await this.parseResponse(
//           response
//         );

//         if (!response.ok) {
//           throw new Error(
//             result.description ||
//             result.message ||
//             'Unable to add product.'
//           );
//         }

//         await this.refreshDrawer();

//         this.openDrawer();

//         this.announce(
//           'Product added to your cart.'
//         );
//       } catch (error) {
//         console.error(
//           'Recommendation add error:',
//           error
//         );

//         this.announce(
//           error.message ||
//           'Unable to add product.'
//         );

//         button.disabled = false;
//         button.classList.remove(
//           'is-loading'
//         );
//         button.innerHTML = originalHtml;
//       } finally {
//         this.isAdding = false;
//       }
//     }

//     async refreshDrawer() {
//       const drawer = this.drawer;

//       if (!drawer) {
//         throw new Error(
//           'Custom cart drawer was not found.'
//         );
//       }

//       const sectionId =
//         drawer.dataset.sectionId;

//       if (!sectionId) {
//         throw new Error(
//           'Custom cart drawer section ID is missing.'
//         );
//       }

//       /*
//        * Section Rendering API:
//        * returns direct section HTML.
//        */
//       const sectionUrl = new URL(
//         window.location.origin +
//         this.getRoute('')
//       );

//       sectionUrl.searchParams.set(
//         'section_id',
//         sectionId
//       );

//       sectionUrl.searchParams.set(
//         '_',
//         Date.now().toString()
//       );

//       const response = await fetch(
//         sectionUrl.toString(),
//         {
//           method: 'GET',
//           headers: {
//             Accept: 'text/html',
//             'X-Requested-With':
//               'XMLHttpRequest'
//           },
//           credentials: 'same-origin',
//           cache: 'no-store'
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           `Unable to refresh cart drawer. Status: ${response.status}`
//         );
//       }

//       const sectionHtml =
//         await response.text();

//       if (!sectionHtml.trim()) {
//         throw new Error(
//           'Cart drawer section returned empty HTML.'
//         );
//       }

//       const parsedDocument =
//         new DOMParser().parseFromString(
//           sectionHtml,
//           'text/html'
//         );

//       const updatedDrawer =
//         parsedDocument.querySelector(
//           this.drawerSelector
//         );

//       if (!updatedDrawer) {
//         console.error(
//           'Returned section HTML:',
//           sectionHtml
//         );

//         throw new Error(
//           'Updated cart drawer markup was not found.'
//         );
//       }

//       const wasOpen =
//         drawer.classList.contains('is-open');

//       /*
//        * Replace drawer content only.
//        * Root custom element remains mounted.
//        */
//       drawer.innerHTML =
//         updatedDrawer.innerHTML;

//       drawer.dataset.sectionId =
//         updatedDrawer.dataset.sectionId ||
//         sectionId;

//       if (wasOpen) {
//         drawer.classList.add('is-open');
//         drawer.setAttribute(
//           'aria-hidden',
//           'false'
//         );

//         document.body.classList.add(
//           'custom-cart-is-open'
//         );
//       }

//       await this.updateCartCount();
//     }

//     async updateCartCount() {
//       try {
//         const response = await fetch(
//           this.getRoute('cart.js'),
//           {
//             method: 'GET',
//             headers: {
//               Accept: 'application/json',
//               'X-Requested-With':
//                 'XMLHttpRequest'
//             },
//             credentials: 'same-origin',
//             cache: 'no-store'
//           }
//         );

//         if (!response.ok) return;

//         const cart = await response.json();

//         document
//           .querySelectorAll(
//             [
//               '[data-cart-count]',
//               '.cart-item-count',
//               '.cart-item-count-header--quantity'
//             ].join(',')
//           )
//           .forEach((element) => {
//             element.textContent =
//               cart.item_count;

//             element.classList.toggle(
//               'is-empty',
//               cart.item_count === 0
//             );
//           });
//       } catch (error) {
//         console.error(
//           'Cart count update error:',
//           error
//         );
//       }
//     }

//     openDrawer(trigger = null) {
//       const drawer = this.drawer;

//       if (!drawer) {
//         console.error(
//           'Custom cart drawer was not found.'
//         );

//         return;
//       }

//       if (trigger) {
//         this.lastFocusedElement = trigger;
//       }

//       drawer.classList.add('is-open');

//       drawer.setAttribute(
//         'aria-hidden',
//         'false'
//       );

//       document.body.classList.add(
//         'custom-cart-is-open'
//       );

//       requestAnimationFrame(() => {
//         drawer
//           .querySelector(
//             '.custom-cart__panel'
//           )
//           ?.focus();
//       });
//     }

//     closeDrawer() {
//       const drawer = this.drawer;

//       if (!drawer) return;

//       drawer.classList.remove('is-open');

//       drawer.setAttribute(
//         'aria-hidden',
//         'true'
//       );

//       document.body.classList.remove(
//         'custom-cart-is-open'
//       );

//       if (
//         this.lastFocusedElement &&
//         typeof this.lastFocusedElement.focus ===
//           'function'
//       ) {
//         this.lastFocusedElement.focus();
//       }
//     }

//     setButtonLoading(button, isLoading) {
//       if (!button) return;

//       if (isLoading) {
//         if (!button.dataset.originalHtml) {
//           button.dataset.originalHtml =
//             button.innerHTML;
//         }

//         button.disabled = true;
//         button.classList.add(
//           'is-loading'
//         );

//         button.innerHTML = 'Adding...';
//       } else {
//         button.disabled = false;
//         button.classList.remove(
//           'is-loading'
//         );

//         button.innerHTML =
//           button.dataset.originalHtml ||
//           'Add to cart';
//       }
//     }

//     setDrawerLoading(isLoading) {
//       const drawer = this.drawer;

//       if (!drawer) return;

//       drawer.classList.toggle(
//         'is-updating',
//         isLoading
//       );

//       drawer
//         .querySelectorAll(
//           [
//             '[data-cart-quantity-minus]',
//             '[data-cart-quantity-plus]',
//             '[data-cart-quantity-input]',
//             '[data-cart-remove]',
//             '[data-recommendation-add]'
//           ].join(',')
//         )
//         .forEach((element) => {
//           element.disabled = isLoading;
//         });
//     }

//     clearFormError(form) {
//       form
//         .querySelectorAll(
//           '.custom-cart-form-error'
//         )
//         .forEach((element) => {
//           element.remove();
//         });
//     }

//     showFormError(form, error) {
//   this.clearFormError(form);

//   const message = this.getErrorMessage(error);

//   const errorElement = document.createElement('div');

//   errorElement.className = 'custom-cart-form-error';
//   errorElement.setAttribute('role', 'alert');

//   errorElement.innerHTML = `
//     <span class="custom-cart-form-error__icon" aria-hidden="true">
//       !
//     </span>

//     <span class="custom-cart-form-error__text">
//       ${this.escapeHtml(message)}
//     </span>
//   `;

//   const submitButton = form.querySelector(
//     this.submitButtonSelector
//   );

//   if (submitButton) {
//     submitButton.insertAdjacentElement(
//       'afterend',
//       errorElement
//     );
//   } else {
//     form.appendChild(errorElement);
//   }
// }

// escapeHtml(value = '') {
//   const element = document.createElement('div');
//   element.textContent = value;
//   return element.innerHTML;
// }

//     getErrorMessage(error) {
//   if (!error) {
//     return 'Something went wrong. Please try again.';
//   }

//   if (typeof error === 'string') {
//     try {
//       const parsed = JSON.parse(error);

//       return (
//         parsed.description ||
//         parsed.message ||
//         'Something went wrong. Please try again.'
//       );
//     } catch {
//       return error;
//     }
//   }

//   return (
//     error.description ||
//     error.message ||
//     'Something went wrong. Please try again.'
//   );
// }

//     announce(message) {
//       const status = this.drawer?.querySelector(
//         '[data-cart-status]'
//       );

//       if (!status) return;

//       status.textContent = '';

//       requestAnimationFrame(() => {
//         status.textContent = message;
//       });
//     }

//     async parseResponse(response) {
//       const contentType =
//         response.headers.get(
//           'content-type'
//         ) || '';

//       if (
//         contentType.includes(
//           'application/json'
//         )
//       ) {
//         return response.json();
//       }

//       const text = await response.text();

//       return {
//         message:
//           text ||
//           'An unexpected error occurred.'
//       };
//     }
//   }

//   const initializeCustomPdpCart = () => {
//     window.customPdpCart =
//       new CustomPdpCart();
//   };

//   if (
//     document.readyState === 'loading'
//   ) {
//     document.addEventListener(
//       'DOMContentLoaded',
//       initializeCustomPdpCart,
//       {
//         once: true
//       }
//     );
//   } else {
//     initializeCustomPdpCart();
//   }
// })();